import { addQuickBetslipId } from "./addQuickBetslipId";
import { addFullBetslipId } from "./addFullBetslipId";
export const addReceiverIdFns = [addQuickBetslipId, addFullBetslipId];
//# sourceMappingURL=index.js.map